<template>
  <div>
    <section id="basic-datatable">
      <div class="row">
        <div class="col-12">
          <div class="text-right mt-2">
            <button type="button" class="btn btn-primary mb-1 mr-2" @click="addEnterpriseUsers">
              <iconify-icon icon="ic:baseline-plus" height="22px"
                            style="transform: translate(5px, 5px);"></iconify-icon>
              <span class=" ml-25">{{ $t('enterprise_users_add_users_button') }}</span>
            </button>
          </div>
          <div class="card px-2">
            <div class="card-content borderStyle">
              <div class="card-header">
                <h5 class="card-title headingColor"> {{ $t('enterprise_users_table_heading') }}</h5>
                <div class="heading-elements">
                  <ul class="list-inline mb-0">
                    <li class="mr-2">
                      <legend>
                        <select class="form-control mr-1" v-model="statusFilter" @change="filterByData">
                          <option selected value="default" disabled>{{ $t('enterprise_users_default_filter') }}</option>
                          <option selected value="all">{{ $t('enterprise_users_all_status_filter') }}</option>
                          <option value="joined"> {{ $t('enterprise_users_module_filter_active_status') }}</option>
                          <option value="banned"> {{ $t('enterprise_users_module_filter_in_active_status') }}</option>
                        </select>
                      </legend>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card-body card-dashboard">
                <div class="text-center">
                  <div class=" spinner-border text-primary" role="status" v-if="loadingData" style="opacity: .6">
                    <span class="sr-only">{{ $t('common_module_loader_label') }}</span>
                  </div>
                  <div class="text-center mt-1" v-if="!enterpriseUsers.length && !loadingData">
                    <p>{{ $t('common_module_label_users_not_found') }}</p>
                  </div>
                  <div class="table-responsive tableTwo" v-if="enterpriseUsers.length">
                    <table class="table zero-configuration" aria-describedby="enterprise user list">
                      <thead class='borderStyle text-left'>
                      <tr>
                        <th class="tableNames">{{ $t('enterprise_users_module_datatable_name') }}</th>
                        <th class="tableNames">{{ $t('enterprise_users_module_datatable_email') }}</th>
                        <th class="tableNames">{{ $t('enterprise_users_module_datatable_phone_number') }}</th>
                        <th class="tableNames">{{ $t('enterprise_users_module_datatable_language') }}</th>
                        <th class="tableNames">{{ $t('enterprise_users_module_datatable_status') }}</th>
                        <th class="tableNames">{{ $t('enterprise_users_module_datatable_actions') }}</th>
                      </tr>
                      </thead>
                      <tbody class='borderStyle text-left'>
                      <tr v-for="user in enterpriseUsers">
                        <td>
                          <span class="nameSpan" v-if="user.name">{{ user.name }}</span>
                          <span class="nameSpan" v-else>-</span>
                        </td>
                        <td>
                          <span class="nameSpan" v-if="user.email">{{ user.email }}</span>
                          <span class="nameSpan" v-else>-</span>
                        </td>
                        <td>
                          <span class="nameSpan" v-if="user.phoneNumber">{{ user.phoneNumber }}</span>
                          <span class="nameSpan" v-else>-</span>
                        </td>
                        <td>
                          <span class="nameSpan" v-if="user.language">{{ languageName(user.language) }}</span>
                          <span class="nameSpan" v-else>-</span>
                        </td>
                        <td>
                          <span v-if="user.status == 'joined'">
                            <em class="bx bxs-circle success font-small-1 mr-50"></em>
                            <span>{{ $t('users_module_datatable_active_status') }}</span>
                          </span>
                          <span v-else-if="user.status == 'invited'">
                            <em class="bx bxs-circle info font-small-1 mr-50"></em>
                            <span>{{ $t('users_module_datatable_invite_status') }}</span>
                          </span>
                          <span v-else>
                            <em class="bx bxs-circle danger font-small-1 mr-50"></em>
                            <span>{{ $t('users_module_datatable_inactive_status') }}</span>
                          </span>
                        </td>
                        <td>
                          <div>

                            <img :src="viewImage" class=" mr-1" style="width:1.5em"
                                 :alt="$t('error_message_for_loading_image')"
                                 @click="viewUser(user.id)">
                            <img :src="editImage" @click="editUser(user.id)"
                                 :alt="$t('error_message_for_loading_image')" class="mr-1 cursor-pointer"
                                 style="width: 18px; margin-bottom: 2px" v-if="user.status !='invited'">
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="modal fade text-left" id="add-user-modal" tabindex="-1" role="dialog"
         aria-labelledby="create-modal-title" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="create-modal-title">{{
                $t('enterprise_user_add_user_popup_heading')
              }}</h3>
            <button type="button" class="close rounded-pill" data-dismiss="modal" aria-label="Close"
                    @click="cancelAddData">
              <img :src="closeImage" :alt="$t('error_message_for_loading_image')">
            </button>
          </div>
          <div class="modal-body">
            <Alert :text="$t('enterprise_profile_first_name_validation')" type="danger" dismissable="false"
                   v-if=" firstNameError"/>
            <Alert :text="$t('enterprise_profile_first_name_validation')" type="danger" dismissable="false"
                   v-if="lastNameError"/>
            <Alert :text="$t('enterprise_user_add_popup_email_validation')" type="danger" dismissable="false"
                   v-if="inValidEmail"/>
            <Alert :text="$t('enterprise_user_add_popup_phone_validation')" type="danger" dismissable="false"
                   v-if="submitted && phoneError"/>
            <Alert :text="$t('enterprise_user_add_popup_country_validation')" type="danger" dismissable="false"
                   v-if="countryError"/>
            <Alert :text="$t('enterprise_user_add_popup_language_validation')" type="danger" dismissable="false"
                   v-if="languageError"/>
            <Alert :text="apiErrorMessage" type="danger" dismissable="false" v-if="apiError"/>
            <form action="#">
              <div class="form-group row">
                <div class="col-6">
                  <label for>{{ $t('enterprise_user_add_user_popup_first_name_label') }}</label>
                  <input type="text" class="form-control height-50"
                         :placeholder="$t('enterprise_user_add_user_popup_first_name_placeholder')"
                         :class="firstNameError ? 'errClass':''"
                         v-model="firstName"/>
                </div>
                <div class="col-6">
                  <label for>{{ $t('enterprise_user_add_user_popup_last_name_label') }}</label>
                  <input type="text" class="form-control height-50"
                         :placeholder="$t('enterprise_user_add_user_popup_last_name_placeholder')"
                         :class="lastNameError ? 'errClass':''"
                         v-model="lastName"/>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-6">
                  <label for>{{ $t('enterprise_user_add_user_popup_email_label') }}</label>
                  <input type="text" class="form-control height-50"
                         :placeholder="$t('enterprise_user_add_user_popup_email_placeholder')"
                         @keyup="validateEmail(emailId)" :class="inValidEmail ? 'errClass':''"
                         v-model="emailId"/>
                </div>
                <div class="col-6">
                  <label for>{{ $t('enterprise_user_add_user_popup_phone_label') }}</label>
                  <PhoneNumberInput :phoneNumber="phoneNumber" :onPhoneNumberChange="onChangePhoneNumber"
                                    :placeholder="$t('enterprise_user_add_user_popup_phone_placeholder')"
                                    :validate="phoneValidate" class="form-control inputStylePhone height-50"
                                    :class="submitted && phoneError ? 'errClass':''"/>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-6">
                  <label for>{{ $t('enterprise_user_add_user_popup_country_label') }}</label>
                  <select class='form-control height-50' :class="countryError ? 'errClass':''"
                          v-model="enterpriseUsersCountry"
                          name="" id="">
                    <option value="default" disabled selected>
                      {{ $t('enterprise_user_add_user_popup_country_dropdown_default') }}
                    </option>
                    <option v-for="(country, index) in totalCountries" :value="country" :key="index">{{
                        countryName(country)
                      }}
                    </option>
                  </select>
                </div>
                <div class="col-6">
                  <label for>{{ $t('enterprise_user_add_user_popup_language_label') }}</label>
                  <select class='form-control height-50' :class="languageError ? 'errClass':''"
                          v-model="enterpriseUsersLanguage"
                          name="" id="">
                    <option value="default" disabled selected>
                      {{ $t('enterprise_user_add_user_popup_language_dropdown_default') }}
                    </option>
                    <option v-for="(language, index) in totalLanguages" :value="language" :key="index">{{
                        languageName(language)
                      }}
                    </option>
                  </select>
                </div>

              </div>
            </form>
          </div>
          <div class="modal-footer borderStyle mt-1">
            <button type="button" class="btn btn-light-secondary" data-dismiss="modal" @click="cancelAddData">
              <em class="bx bx-x d-block d-sm-none"></em>
              <span class="d-none d-sm-block">{{ $t('clo_user_view_cancel_button') }}</span>
            </button>
            <button type="button" class="btn btn-primary ml-1" @click="addUserData">
              <em class="bx bx-check d-block d-sm-none"></em>
              <span class="d-none d-sm-block">{{ $t('clo_user_add_popup_add_button') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--    add confirm popup starts -->
    <div
      class="modal fade text-left"
      id="add-enterprise-confirm-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="create-modal-title"
      aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content ">
          <div class="modal-header">
            <h3 class="modal-title resetPasswordHeading" id="create-modal-title">
              {{ $t('add_success_confirm_popup_heading') }}</h3>
            <button
              type="button"
              class="close rounded-pill"
              data-dismiss="modal"
              aria-label="Close">
              <img :src="closeImage" :alt="$t('error_message_for_image')">
            </button>
          </div>
          <div class="modal-body">
            <h3 class="modal-title resetPasswordSuccessHeading" id="create-modal-title">
              {{ $t('add_success_confirm_popup_description') }}</h3>
          </div>
          <div class="modal-footer modalFooter">
            <button type="button" class="btn btn-primary ml-1" data-dismiss="modal"
                    aria-label="Close">
              <em class="bx bx-check d-block d-sm-none"></em>
              <span class="d-none d-sm-block">{{ $t('users_edit_module_confirmation_popup_ok_button') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--    add confirm popup ends-->
    <!--    edit user popup starts-->
    <div class="modal fade text-left" id="enterprise-edit-user-modal" tabindex="-1" role="dialog"
         aria-labelledby="create-modal-title" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="create-modal-title">{{
                $t('edit_enterprise_user_heading')
              }}</h3>
            <button type="button" class="close rounded-pill" data-dismiss="modal" aria-label="Close">
              <img :src="closeImage" :alt="$t('error_message_for_loading_image')">
            </button>
          </div>
          <div class="modal-body">
            <Alert :text="$t('enterprise_profile_first_name_validation')" type="danger" dismissable="false"
                   v-if=" editFirstNameError"/>
            <Alert :text="$t('enterprise_profile_first_name_validation')" type="danger" dismissable="false"
                   v-if="editLastNameError"/>
            <Alert :text="$t('enterprise_user_add_popup_email_validation')" type="danger" dismissable="false"
                   v-if="editInValidEmail"/>
            <Alert :text="$t('enterprise_user_add_popup_phone_validation')" type="danger" dismissable="false"
                   v-if="editPhoneSaveValidate && editPhoneError"/>
            <Alert :text="$t('enterprise_user_add_popup_country_validation')" type="danger" dismissable="false"
                   v-if="editCountryError"/>
            <Alert :text="$t('enterprise_user_add_popup_language_validation')" type="danger" dismissable="false"
                   v-if="editlanguageError"/>
            <Alert :text="apiErrorMessage" type="danger" dismissable="false" v-if="apiError"/>
            <form action="#">
              <div class="form-group row">
                <div class="col-6">
                  <label for>{{ $t('enterprise_user_add_user_popup_first_name_label') }}</label>
                  <input type="text" class="form-control height-50"
                         :placeholder="$t('enterprise_user_add_user_popup_first_name_placeholder')"
                         :class="editFirstNameError ? 'errClass':''"
                         v-model="editFirstName"/>
                </div>
                <div class="col-6">
                  <label for>{{ $t('enterprise_user_add_user_popup_last_name_label') }}</label>
                  <input type="text" class="form-control height-50"
                         :placeholder="$t('enterprise_user_add_user_popup_last_name_placeholder')"
                         :class="editLastNameError ? 'errClass':''"
                         v-model="editLastName"/>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-6">
                  <label for>{{ $t('enterprise_user_add_user_popup_email_label') }}</label>
                  <input type="text" class="form-control height-50"
                         :placeholder="$t('enterprise_user_add_user_popup_email_placeholder')"
                         @keyup="validateEditEmail(editEmailId)" :class="editInValidEmail ? 'errClass':''"
                         v-model="editEmailId"/>
                </div>
                <div class="col-6">
                  <label for>{{ $t('enterprise_user_add_user_popup_phone_label') }}</label>
                  <PhoneNumberInput :phoneNumber="editPhoneNumber" :onPhoneNumberChange="onChangePhoneEditNumber"
                                    :placeholder="$t('enterprise_user_add_user_popup_phone_placeholder')"
                                    :validate="editPhoneValidate" class="form-control inputStylePhone height-50"
                                    :class="editPhoneSaveValidate && editPhoneError ? 'errClass':''"/>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-6">
                  <label for>{{ $t('enterprise_user_add_user_popup_country_label') }}</label>
                  <select class='form-control height-50' :class="editCountryError ? 'errClass':''"
                          v-model="editEnterpriseUsersCountry"
                          name="" id="">
                    <option value="default" disabled selected>
                      {{ $t('enterprise_user_add_user_popup_country_dropdown_default') }}
                    </option>
                    <option v-for="(country, index) in totalCountries" :value="country" :key="index">{{
                        countryName(country)
                      }}
                    </option>
                  </select>
                </div>
                <div class="col-6">
                  <label for>{{ $t('enterprise_user_add_user_popup_language_label') }}</label>
                  <select class='form-control height-50' :class="editlanguageError ? 'errClass':''"
                          v-model="editEnterpriseUsersLanguage"
                          name="" id="">
                    <option value="default" disabled selected>
                      {{ $t('enterprise_user_add_user_popup_language_dropdown_default') }}
                    </option>
                    <option v-for="(language, index) in totalLanguages" :value="language" :key="index">{{
                        languageName(language)
                      }}
                    </option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer borderStyle mt-1">
            <button type="button" class="btn btn-light-secondary" data-dismiss="modal" @click="editModalClose">
              <em class="bx bx-x d-block d-sm-none"></em>
              <span class="d-none d-sm-block">{{ $t('clo_user_view_cancel_button') }}</span>
            </button>
            <button type="button" class="btn btn-primary ml-1" @click="editUsersData">
              <em class="bx bx-check d-block d-sm-none"></em>
              <span class="d-none d-sm-block">{{ $t('clo_user_view_save_changes_button') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--    edit user popup ends-->
    <!--    edit confirm popup starts -->
    <div
      class="modal fade text-left"
      id="edit-enterprise-confirm-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="create-modal-title"
      aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content ">
          <div class="modal-header">
            <h3 class="modal-title resetPasswordHeading" id="create-modal-title">
              {{ $t('edit_success_confirm_popup_heading') }}</h3>
            <button
              type="button"
              class="close rounded-pill"
              data-dismiss="modal"
              aria-label="Close">
              <img :src="closeImage" :alt="$t('error_message_for_image')">
            </button>
          </div>
          <div class="modal-body">
            <h3 class="modal-title resetPasswordSuccessHeading" id="create-modal-title">
              {{ $t('edit_success_confirm_popup_description') }}</h3>
          </div>
          <div class="modal-footer modalFooter">
            <button type="button" class="btn btn-primary ml-1" data-dismiss="modal" @click="getEnterpriseUsers"
                    aria-label="Close">
              <em class="bx bx-check d-block d-sm-none"></em>
              <span class="d-none d-sm-block">{{ $t('users_edit_module_confirmation_popup_ok_button') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--    edit confirm popup ends-->
    <!--    view confirm popup starts -->
    <div
      class="modal fade text-left"
      id="view-enterprise-confirm-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="create-modal-title"
      aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content ">
          <div class="modal-header">
            <h3 class="modal-title resetPasswordHeading" id="create-modal-title">
              {{ $t('add_enterprise_user_heading') }}</h3>
            <button
              type="button"
              class="close rounded-pill"
              data-dismiss="modal"
              aria-label="Close">
              <img :src="closeImage" :alt="$t('error_message_for_image')">
            </button>
          </div>
          <div class="modal-body">
            <h3 class="modal-title resetPasswordSuccessHeading" id="create-modal-title">
              {{ $t('add_enterprise_user_description') }}</h3>
          </div>
          <div class="modal-footer modalFooter">
            <button type="button" class="btn btn-primary ml-1" data-dismiss="modal"
                    aria-label="Close">
              <em class="bx bx-check d-block d-sm-none"></em>
              <span class="d-none d-sm-block">{{ $t('users_edit_module_confirmation_popup_ok_button') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--    view confirm popup ends-->
    <!--    view user popup starts-->
    <div class="modal fade text-left" id="enterprise-view-user-modal" tabindex="-1" role="dialog"
         aria-labelledby="create-modal-title" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="create-modal-title">{{
                $t('view_enterprise_user_heading')
              }}</h3>
            <button type="button" class="close rounded-pill" data-dismiss="modal" aria-label="Close">
              <img :src="closeImage" :alt="$t('error_message_for_loading_image')">
            </button>
          </div>
          <div class="modal-body">
            <form action="#">
              <div class="form-group row">
                <div class="col-6">
                  <label for>{{ $t('enterprise_user_add_user_popup_first_name_label') }}</label>
                  <input type="text" class="form-control height-50"
                         v-model="editFirstName" disabled/>
                </div>
                <div class="col-6">
                  <label for>{{ $t('enterprise_user_add_user_popup_last_name_label') }}</label>
                  <input type="text" class="form-control height-50"
                         v-model="editLastName" disabled/>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-6">
                  <label for>{{ $t('enterprise_user_add_user_popup_email_label') }}</label>
                  <input type="text" class="form-control height-50"
                         v-model="editEmailId" disabled/>
                </div>
                <div class="col-6">
                  <label for>{{ $t('enterprise_user_add_user_popup_phone_label') }}</label>
                  <PhoneNumberInput :phoneNumber="editPhoneNumber" :onPhoneNumberChange="onChangePhoneEditNumber"
                                    class="form-control inputStylePhone height-50" disabled/>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-6">
                  <label for>{{ $t('enterprise_user_add_user_popup_country_label') }}</label>
                  <select class='form-control height-50' v-model="editEnterpriseUsersCountry"
                          name="" id="" disabled>
                    <option value="default" disabled selected>
                      {{ $t('enterprise_user_add_user_popup_country_dropdown_default') }}
                    </option>
                    <option v-for="(country, index) in totalCountries" :value="country" :key="index">{{
                        countryName(country)
                      }}
                    </option>
                  </select>
                </div>
                <div class="col-6">
                  <label for>{{ $t('enterprise_user_add_user_popup_language_label') }}</label>
                  <select class='form-control height-50' :class="editlanguageError ? 'errClass':''" disabled
                          v-model="editEnterpriseUsersLanguage"
                          name="" id="">
                    <option value="default" disabled selected>
                      {{ $t('enterprise_user_add_user_popup_language_dropdown_default') }}
                    </option>
                    <option v-for="(language, index) in totalLanguages" :value="language" :key="index">{{
                        languageName(language)
                      }}
                    </option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer borderStyle mt-1">
            <button type="button" class="btn btn-light-secondary" data-dismiss="modal">
              <em class="bx bx-x d-block d-sm-none"></em>
              <span class="d-none d-sm-block">{{ $t('clo_user_view_cancel_button') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--    view user popup ends-->
  </div>
</template>

<script>
import PhoneNumberInput from "@/components/PhoneNumberInput/PhoneNumberInput";
import Alert from "@/components/Alerts";
import {getCountryName} from "@/app-assets/js/get-countries.js";
import {getLanguageName} from "@/app-assets/js/get-language.js";

export default {
  name: "EnterpriseUsers",
  components: {
    PhoneNumberInput,
    Alert
  },
  data() {
    return {
      statusFilter: 'default',
      loadingData: true,
      enterpriseUsers: [],
      viewImage: require('@/assets/Vector.png').default,
      editImage: require('@/assets/editing.png').default,
      closeImage: require('@/assets/close.png').default,
      firstName: '',
      lastName: '',
      emailId: '',
      entId: this.$route.params.ent,
      editFirstName: '',
      editLastName: '',
      editEmailId: '',
      phoneNumber: '',
      editPhoneNumber: '',
      enterpriseUsersCountry: 'default',
      editEnterpriseUsersCountry: 'default',
      editEnterpriseUsersLanguage: 'default',
      totalCountries: [],
      totalLanguages: [],
      firstNameError: false,
      lastNameError: false,
      inValidEmail: false,
      phoneError: false,
      countryError: false,
      editFirstNameError: false,
      editLastNameError: false,
      editInValidEmail: false,
      editPhoneError: false,
      editPhoneSaveValidate: false,
      editCountryError: false,
      editlanguageError: false,
      submitted: false,
      apiError: false,
      apiErrorMessage: '',
      enterpriseUsersLanguage: 'default',
      languageError: false,
      enterpriseObj: {},
      userId: ''
    }
  },
  methods: {
    addEnterpriseUsers() {
      $("#add-user-modal").modal();
    },
    onChangePhoneNumber(value) {
      let self = this
      self.phoneNumber = value;
    },
    onChangePhoneEditNumber(value) {
      let self = this
      self.phoneNumber = value;
    },
    countryName(element) {
      if (element) {
        return getCountryName(element.toUpperCase());
      }
    },
    validateEmail(email) {
      let self = this;
      if (/^[^@]+@\w+(\.\w+)+\w$/.test(email)) {
        self.inValidEmail = false;
      } else {
        self.inValidEmail = true;
      }
    },
    getLanguages() {
      console.log(" get languages")
      let self = this;
      this.$apiCall.get(`v1/settings/languages`).then((response) => {
        self.totalLanguages = response.data.dashboardLanguages;
      })
    },
    languageName(element) {
      if (element) {
        return getLanguageName(element);
      }
    },
    validateEditEmail(email) {
      let self = this;
      if (/^[^@]+@\w+(\.\w+)+\w$/.test(email)) {
        self.editInValidEmail = false;
      } else {
        self.editInValidEmail = true;
      }
    },
    editEnterpriseConfirmPopup() {
      $('#edit-enterprise-confirm-modal').modal()
    },
    addEnterpriseConfirmPopup() {
      $('#add-enterprise-confirm-modal').modal()
    },
    filterByData() {
      let self = this;
      self.enterpriseUsers = [];
      self.loadingData = true;
      let filterData = {};
      if (self.statusFilter != 'all') {
        filterData.status = self.statusFilter;
      }
      if (filterData.status) {
        self.filterApiCall(filterData)
      }
      if (self.statusFilter == 'all') {
        self.enterpriseUsers = [];
        self.loadingData = true;
        self.getEnterpriseUsers()
      }
    },
    editModalClose() {
      let self = this;
      self.editFirstNameError = false;
      self.editLastNameError = false;
      self.editInValidEmail = false;
      self.editCountryError = false;
      self.editlanguageError = false;
    },
    filterApiCall(data) {
      let self = this;
      self.$apiCall
        .get(`v1/enterpriseaccount/${self.entId}/admins`, {params: data})
        .then(response => {
          self.loadingData = false;
          self.enterpriseUsers = response.data.data;
          self.initDataTable();
        })
    },
    initDataTable() {
      let self = this
      setTimeout(function () {
        $('.zero-configuration').DataTable({
          "bLengthChange": false,
          "bFilter": false,
          "order": []
        });
        $.fn.dataTable.ext.errMode = 'none';
      }, 100)
    },
    getCountries() {
      let self = this;
      self.totalCountries = ['lb', 'jo', 'pl', 'ua', 'us', 'ca', 'pe', 'co']
    },
    isRequiredValidate() {
      let self = this;
      if (self.editFirstName != '') {
        self.editFirstNameError = false;
      } else {
        self.editFirstNameError = true;
      }
      if (self.editLastName != '') {
        self.editLastNameError = false;
      } else {
        self.editLastNameError = true;
      }
      if (self.editEmailId != '') {
        self.editInValidEmail = false;
      } else {
        self.editInValidEmail = true;
      }
      if (self.editPhoneNumber != '') {
        self.editPhoneError = false;
      } else {
        self.editPhoneError = true;
      }
      if (self.editEnterpriseUsersCountry != 'default') {
        self.editCountryError = false;
      } else {
        self.editCountryError = true;
      }
      if (self.editEnterpriseUsersLanguage != 'default') {
        self.editlanguageError = false;
      } else {
        self.editlanguageError = true;
      }

    },
    getEnterpriseUsers() {
      let self = this;
      self.loadingData = true;
      this.$apiCall.get(`v1/enterpriseaccount/${self.entId}/admins`).then((response) => {
        console.log("response of get", response.data);
        self.loadingData = false;
        self.enterpriseUsers = response.data.data;
        self.initDataTable();
        console.log('enterprise-users', self.enterpriseUsers)
      })
    },
    editUsersData() {
      let self = this;
      self.editPhoneSaveValidate = true;
      self.isRequiredValidate()
      if (!self.editFirstNameError && !self.editLastNameError && !self.editInValidEmail && !self.editCountryError && !self.editlanguageError) {
        let body = {
          phoneNumber: self.editPhoneNumber,
          country: self.editEnterpriseUsersCountry,
          lastName: self.editLastName,
          firstName: self.editFirstName,
          language: self.editEnterpriseUsersLanguage,
          email: self.editEmailId
        }
        this.$apiCall.patch(`v1/admins/${self.userId}`, body).then((response) => {
          console.log("response of patch", response)
          if (response.status == 201 || 200) {
            $("#enterprise-edit-user-modal").modal("hide");
            self.editEnterpriseConfirmPopup();
          } else {
            self.apiError = true;
            self.apiErrorMessage = response.error.message
          }

        })
      }

    },
    phoneValidate(telnumber) {
      console.log("PhoneValidate ", telnumber)
      let self = this
      if (telnumber.valid) {
        self.phoneError = false;
      } else {
        self.phoneError = true;
      }
    },
    cancelAddData() {
      let self = this;
      self.firstName = '';
      self.lastName = '';
      self.emailId = '';
      self.phoneNumber = '';
      self.enterpriseUsersCountry = 'default';
      self.enterpriseUsersLanguage = 'default'
      self.firstNameError = false;
      self.lastNameError = false;
      self.inValidEmail = false;
      self.submitted = false;
      self.countryError = false;
      self.languageError = false;
    },
    editPhoneValidate(telnumber) {
      console.log("PhoneValidate ", telnumber)
      let self = this
      if (telnumber.valid) {
        self.editPhoneError = false;
      } else {
        self.editPhoneError = true;
      }
    },
    addUserData() {
      let self = this;
      self.isRequired()
      console.log("enterprise-id", self.entId)
      let body = {
        firstName: self.firstName,
        lastName: self.lastName,
        email: self.emailId,
        phoneNumber: self.phoneNumber,
        country: self.enterpriseUsersCountry,
        language: self.enterpriseUsersLanguage
      }
      if (self.submitted && !self.firstNameError && !self.lastNameError && !self.inValidEmail && !self.phoneError && !self.countryError && !self.languageError) {
        this.$apiCall
          .post(`v1/enterpriseaccount/${self.entId}/invite`, body).then((response) => {
          $("#add-user-modal").modal("hide");
          self.addEnterpriseConfirmPopup()
        }).catch((error) => {
          self.apiError = true;
          error.message = self.apiErrorMessage
        })
      }

    },
    isRequired() {
      let self = this;
      self.submitted = true;
      if (self.firstName != '') {
        self.firstNameError = false;
      } else {
        self.firstNameError = true;
      }
      if (self.lastName != '') {
        self.lastNameError = false;
      } else {
        self.lastNameError = true;
      }
      if (self.emailId != '') {
        self.inValidEmail = false;
      } else {
        self.inValidEmail = true;
      }

      if (self.enterpriseUsersCountry != 'default') {
        self.countryError = false;
      } else {
        self.countryError = true;
      }
      if (self.enterpriseUsersLanguage != 'default') {
        self.languageError = false;
      } else {
        self.languageError = true;
      }

    },
    editUser(id) {
      $("#enterprise-edit-user-modal").modal();
      let self = this;
      self.userId = id;
      self.enterpriseObj = self.enterpriseUsers.find(item => item.id === id);
      console.log("each user", self.enterpriseObj)
      self.editFirstName = self.enterpriseObj.firstName;
      self.editLastName = self.enterpriseObj.lastName;
      self.editEmailId = self.enterpriseObj.email;
      self.editPhoneNumber = self.enterpriseObj.phoneNumber;
      self.editEnterpriseUsersCountry = self.enterpriseObj.country;
      self.editEnterpriseUsersLanguage = self.enterpriseObj.language;
    },
    viewUser(id) {
      let self = this;
      $("#enterprise-view-user-modal").modal();
      console.log('id', id);
      self.userId = id;
      self.enterpriseObj = self.enterpriseUsers.find(item => item.id === id);
      console.log("each user", self.enterpriseObj)
      self.editFirstName = self.enterpriseObj.firstName;
      self.editLastName = self.enterpriseObj.lastName;
      self.editEmailId = self.enterpriseObj.email;
      self.editPhoneNumber = self.enterpriseObj.phoneNumber;
      self.editEnterpriseUsersCountry = self.enterpriseObj.country;
      self.editEnterpriseUsersLanguage = self.enterpriseObj.language;
    },
    viewUserConfirmPopUp() {
      $("#view-enterprise-confirm-modal").modal();
    }
  },
  mounted() {
    this.getLanguages()
    this.getCountries()
    this.getEnterpriseUsers()
  }
}
</script>

<style scoped>
.borderStyle {
  border: 1px solid #DFE3E7;
}

.headingColor {
  color: #475F7B;
}

.inputStylePhone {
  border: 1px solid #DFE3E7;
  margin-left: 0em;
}

.tableNames {
  font-size: 1rem
}

.errClass {
  border: 1px solid red;
}

.imageStyle {
  margin-left: 30px;
}

::v-deep .tableTwo {
  text-align: left !important;
}


</style>
